import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { HttpClient, HttpRequest, HttpHeaders, HttpErrorResponse, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-s3-upload',
  templateUrl: './s3-upload.component.html',
  styleUrls: ['./s3-upload.component.scss']
})
export class S3UploadComponent implements OnInit {

  public user:any;
  public domainId;
  public userId;
  public roleId;

  private serverUrl: string;
  public uploadFlag: any = null;
    selectedFileName: string | null = null;
  selectedFile: File | null = null;
  message='';
  public progress = 0;

  constructor( private http: HttpClient,private commonApi: CommonService, private authenticationService:AuthenticationService, public apiUrl: ApiService) { }

  ngOnInit(): void {

    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.roleId = this.user.roleId;
    this.userId = this.user.Userid;

  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.message = null;
      this.progress = null;
    }
  }

  onUpload(): void {
    if (!this.selectedFile) {
      this.message = 'Please select a file first.';
      return;
    }

    const file = this.selectedFile;
    const fileName = `uploads/${Date.now()}_${file.name}`;
    const contentType = file.type;

    this.http.get<{ url: string }>('https://collabtic-pre-prod-v3api.collabtic.com/v1/market-place/getpresignedurl', {
      params: {
        fileName: fileName,
        contentType: contentType
      }
    }).subscribe({
      next: ({ url }) => {
        const headers = new HttpHeaders({ 'Content-Type': contentType });

        this.http.put(url, file, {
          // headers,
          reportProgress: true,
          observe: 'events'
        }).subscribe({
          next: event => {
            if (event.type === HttpEventType.UploadProgress && event.total) {
              this.progress = Math.round((event.loaded / event.total) * 100);
            } else if (event.type === HttpEventType.Response) {
              this.message = 'Upload successful!';
              this.selectedFile = null;
            }
          },
          error: err => {
            console.error('Upload failed:', err);
            this.message = 'Upload failed.';
          }
        });
      },
      error: err => {
        console.error('Failed to get pre-signed URL:', err);
        this.message = 'Could not get upload URL.';
      }
    });
  }


}
